// extracted by mini-css-extract-plugin
export default {"header":"VV4E8l","headerNF":"cgB2YQ","headerNf":"cgB2YQ","column":"KB8JSk"};